unable to read source [project]/nextapp/node_modules/https-proxy-agent/src/parse-proxy-response.ts